// extracted by mini-css-extract-plugin
export default {"wrapper":"nvW6e1PvRcwVtt5IqvCp","content":"Qm7JoViz6wlI8VC1oMz1","isClickable":"haDt95zPK4SbdAHrX63f","expandIcon":"fqehhZi_yQnRjRfE4Ij9"};